import { ApiResponse } from '../../../../constants/types';
import { DalantStudentItem } from '../../../../constants/types/lms/dalant/type';
import instance from '../../../axios/utils.ts/instance';

interface VoucherListParams {
  classId: string;
  classGroupId?: number;
}

/**
 * LMS > 달란트 관리 :반별 학생 달란트 현황 조회
 * @param classId
 * @param classGroupId
 * @returns
 */
export const getDalantStudentList = async (params: VoucherListParams) => {
  const { classId, ...rest } = params;

  const result = await instance.get<
    ApiResponse<{ classId: string; students: DalantStudentItem[] }>
  >(`/v1/jebspl/dalant/class/${classId}/summary`, {
    params: rest,
  });
  return result.data.data;
};

interface PostDalantPointsParams {
  classId: string;
  studentId: number;
  points: number;
  reason: string;
}

/**
 * LMS > 달란트 관리 : 달란트 적립/차감
 * @param classId
 * @param studentId
 * @param points
 * @param reason
 * @returns
 */
export const postDalantPoints = async (params: PostDalantPointsParams) => {
  const { classId, ...rest } = params;

  const result = await instance.post(
    `/v1/jebspl/dalant/class/${classId}/grant`,
    rest,
  );

  return result.data.data;
};

interface PostDalantInvalidateParams {
  classId: string;
  studentIds: number[];
  reason: string;
}

/**
 * LMS > 달란트 관리 : 달란트 일괄 초기화
 * @param classId
 * @param studentIds
 * @param reason
 * @returns
 */
export const postDalantInvalidate = async (
  params: PostDalantInvalidateParams,
) => {
  const { classId, ...rest } = params;

  const result = await instance.post(
    `/v1/jebspl/dalant/class/${classId}/invalidate`,
    rest,
  );

  return result.data.data;
};
